import Plotly from 'react-plotly.js'

export type AskResponse = {
    answer: string
    sources: string[]
    error?: string
    message_id?: string
    feedback?: Feedback
    supported_topics: string[],
    tracer: string
}

export type Citation = {
    part_index?: number
    content: string
    id: string
    title: string | null
    filepath: string | null
    url: string | null
    metadata: string | null
    chunk_id: string | null
    reindex_id: string | null
}

export type ToolMessageContent = {
    citations: Citation[]
    intent: string
}

export type AzureSqlServerCodeExecResult = {
    data: Plotly.Data[]
    layout: Partial<Plotly.Layout>
}

export type AzureSqlServerExecResult = {
    intent: string
    search_query: string | null
    search_result: string | null
    code_generated: string | null
    code_exec_result?: AzureSqlServerCodeExecResult | undefined
}

export type AzureSqlServerExecResults = {
    all_exec_results: AzureSqlServerExecResult[]
}

export type ChatMessage = {
    id: string
    role: string
    content: string
    end_turn?: boolean
    date: string
    feedback?: Feedback
    context?: string,
    sources: string[],
    supported_topics: string[],
    tracer:string,
}

export type ExecResults = {
    intent: string
    search_query: string | null
    search_result: string | null
    code_generated: string | null
}

export type Conversation = {
    id: string
    title: string
    messages: ChatMessage[]
    date: string
}

export type ChatConversationResponse = {
    conversation_id: string
    msg_id: string
    error?: any
}

export type ChatMsgResponse = {
    conversation_id: string
    msg_id: string
    content: string
    response_ready: boolean
    error?: any
    sources: string[],
    supported_topics: string[],
    tracer: string
}

export type ConversationRequest = {
    conversation_id: string
    messages: ChatMessage[]
}

export type MessageRequest = {
    conversation_id: string
    message_id: string
}

export type UserInfo = {
    access_token: string
    expires_on: string
    id_token: string
    provider_name: string
    user_claims: any[]
    user_id: string
}

export interface LoginRequest {
    user_id: string;
}

export enum CosmosDBStatus {
    NotConfigured = 'CosmosDB is not configured',
    NotWorking = 'CosmosDB is not working',
    InvalidCredentials = 'CosmosDB has invalid credentials',
    InvalidDatabase = 'Invalid CosmosDB database name',
    InvalidContainer = 'Invalid CosmosDB container name',
    Working = 'CosmosDB is configured and working'
}

export type CosmosDBHealth = {
    cosmosDB: boolean
    status: string
}

export enum ChatHistoryLoadingState {
    Loading = 'loading',
    Success = 'success',
    Fail = 'fail',
    NotStarted = 'notStarted'
}

export type ErrorMessage = {
    title: string
    subtitle: string
}

export type UI = {
    title: string
    chat_title: string
    chat_description: string
    logo?: string
    chat_logo?: string
    show_share_button?: boolean
    show_chat_history_button?: boolean
    supported_topics: string[]
}

export type FrontendSettings = {
    auth_enabled?: string | null
    feedback_enabled?: string | null
    ui?: UI
    sanitize_answer?: boolean
}

export enum Feedback {
    Neutral = 'neutral',
    Positive = 'positive',
    Negative = 'negative',
    IncorrectAnswer = 'incorrect_answer',
    UnclearAnswer = 'unclear_answer',
    Irrelevant = 'irrelevant',
    TooLong = 'inaccurate_or_irrelevant',
    Incomplete = 'incomplete',
    OtherUnhelpful = 'other_unhelpful',
    HateSpeech = 'hate_speech',
    Violent = 'violent',
    Sexual = 'sexual',
    Manipulative = 'manipulative',
    OtherHarmful = 'other_harmlful'
}